import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import sanityClient from '../../../sanityClient';
import { PortableText } from '@portabletext/react';
import urlBuilder from '@sanity/image-url';
import '../../../assets/css/views/blogPost.css';
import { portableTextComponents } from '../../../components/blog/PortableTextComponents';

const builder = urlBuilder(sanityClient);

function urlFor(source) {
  return builder.image(source);
}

const BlogPost = () => {
  const [post, setPost] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == $slug]{
          title,
          _id,
          slug,
          mainImage{
            asset->{
              _id,
              url
            }
          },
          body,
          publishedAt,
          "categories": categories[]->title,
          "authorName": author->name,
          "authorImage": author->image
        }`,
        { slug }
      )
      .then((data) => setPost(data[0]))
      .catch(console.error);
  }, [slug]);

  if (!post) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="blog-post-hero">
        <h1>{post.title}</h1>
        <div className="post-meta">
          {post.authorImage && <img src={urlFor(post.authorImage).width(40).url()} alt={post.authorName} className="meta-author-image"/>}
          {post.authorName && <span className="meta-info">By {post.authorName}</span>}
          {post.publishedAt && <span className="meta-info">Published: {new Date(post.publishedAt).toLocaleDateString()}</span>}
          {post.categories && <span className="meta-info">Categories: {post.categories.join(', ')}</span>}
        </div>
      </div>
      <article className="blog-post-container">
        {post.mainImage && <img className="main-image" src={post.mainImage.asset.url} alt={post.title} />}
        <div className="post-body">
          <PortableText value={post.body} components={portableTextComponents} />
        </div>
      </article>
    </>
  );
};

export default BlogPost;
